import React from "react";
import styles from "./ViewerInfoBar.module.css";
import { FaInfoCircle, FaSignOutAlt, FaTimes } from "react-icons/fa";

import { useStoreActions, useStoreState } from "../../hooks";
import { getHubViewer, getUserLoggedIn, userLogout } from "../../services/auth";
import { isEmpty } from "lodash";

const { useState } = React;

const ViewerInfoBar = () => {
  const [showLogout, setShowLogout] = useState(false);

  const serviceDetails = useStoreState(
    (state) => state.userStore.servicesDetails
  );

  const hubViewer = getHubViewer();

  const authUser = getUserLoggedIn();

  const onLogout = () => {
    userLogout(() => {
      window.location = "/";
    });
  };

  return (
    <div
      className={`${
        styles.mainContainer
      } flex justify-center items-center px-4  ${
        isEmpty(getHubViewer()) ? "hidden" : ""
      }`}
    >
      {/* {showLogout && (
        <LogoutModal
          visibility={showLogout}
          onOpenModal={() => setShowLogout(true)}
          onCloseModal={() => setShowLogout(false)}
        />
      )} */}
      <div className={`${styles.container} flex justify-between items-center`}>
        <div className={`flex justify-center items-center`}>
          <FaInfoCircle className={`${styles.infoIcon} mx-2`} />
          <div className={styles.infoText}>
            {" "}
            You are currently viewing as{" "}
            {!isEmpty(authUser) ? authUser.name : ""}, Administrator of{" "}
            {!isEmpty(serviceDetails) && !isEmpty(authUser)
              ? serviceDetails.filter((service) => {
                  return Number(service.id) === Number(authUser.center_id);
                })[0].name
              : ""}
          </div>
        </div>
        <div className={`flex justify-center items-center`}>
          <div
            onClick={() => onLogout()}
            className={`${styles.logoutButton} hover:opacity-90 flex justify-center items-center`}
          >
            <FaSignOutAlt className={styles.buttonIcon} />{" "}
            <span className={`${styles.buttonText} ml-2`}> Logout</span>
          </div>
          <div
            onClick={() => {
              window.close();
            }}
            className={`${styles.closeButton} hover:opacity-90 flex justify-center items-center ml-3`}
          >
            <FaTimes className={styles.buttonIcon} />{" "}
            <span className={`${styles.buttonText} ml-2`}>Close</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewerInfoBar;
